import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import { useIncomingInvoiceDeliveryNotes } from "@/hooks/use-incoming-invoice-delivery-notes";
import { columns } from "./table-config";

/**
 * Every delivery note the organisation received, newest first — the ones linked to the invoice
 * that bills them and, so none is lost, the ones still waiting for it.
 */
export function IncomingInvoiceDeliveryNotes() {
	/** Query */
	const { deliveryNotes, isLoading, queryKey, refetch } = useIncomingInvoiceDeliveryNotes();

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={deliveryNotes}
				columns={columns}
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				menu={null}
				persistenceKey="incoming-invoice-delivery-notes-table"
			/>
		</ContentBox>
	);
}
